module.exports = __webpack_public_path__ + "img/pampers@2x.fd4a3788.png";